export const bookingWidgetFeatures = {
    showWithTrainers: false
};
